<template>
    <div>
        <Breadcrumb section-name="Income" :breadcrumb="breadCrumb" :btn-name="'Add '+ breadCrumb"
                    :click-action="incomeAdd"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <Table :tbl-data="table" :param="param"></Table>
                </div>
            </div>
        </div>
        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import Table from "../Common/Table";
import DownloadService from "../../Services/DownloadService";
import ConfirmDialogue from "../Common/confirmPopup/ConfirmDialogue";
import dayjs from "dayjs";
export default {
    components: {Table, Breadcrumb, ConfirmDialogue},
    data() {
        return {
            breadCrumb: [],
            param: {
                keyword: '',
                limit: 10,
                order_by: 'id',
                order_mode: 'DESC',
                page: 1,
                start_date: '',
                end_date: '',
                project_id: '',
                income_category_id: '',
                payment_method: '',
                cash_received_by: ''
            },
            table: {
                columns: [
                    {type: 'text', key: 'date', label: 'Date', sortable: true},
                    {type: 'text', key: 'project_name', label: 'Project', photo: true, sortable: true},
                    {type: 'text', key: 'category_name', label: 'Category Name', photo: true, sortable: true},
                    {type: 'text', key: 'payment_method', label: 'Payment Method', sortable: true},
                    {type: 'text', key: 'deposit_by', label: 'Deposit By', sortable: true},
                    {type: 'text', key: 'bank_name', label: 'Bank Name', sortable: true},
                    {type: 'text', key: 'check_number', label: 'Check Number', sortable: true},
                    {type: 'text', key: 'cash_received_by', label: 'Cash Received By', sortable: true},
                    {type: 'text', key: 'remarks', label: 'Remarks', sortable: true},
                    {type: 'text', key: 'amount', label: 'Amount', sortable: true},
                ],
                rows: [],
                row_actions: [
                    {name: 'print', type: 'action', label: 'bx bx-printer', color: 'btn-primary', loading: false},
                    {name: 'edit', type: 'action', label: 'bx bx-pencil', color: 'btn-info'},
                    {name: 'delete', type: 'action', label: 'bx bx-trash', color: 'btn-gradient-danger'}
                ],
                tableIconAction: (data) => {
                    this.tableIconAction(data.row_action, data.row_data, data.row_index);
                },
                tableLoading: false,
                paginateData: {},
                updatePagination: (page) => {
                    this.list(page)
                },
                updateFilter: (param) => {
                    this.param = param
                    this.list()
                },
                dateSearch: {
                    selectedDate: '',
                    mode: 'range',
                    action: (event) => {
                        if (event.length > 1) {
                            this.param.start_date = dayjs(event[0]).format('YYYY-MM-DD')
                            this.param.end_date = dayjs(event[1]).format('YYYY-MM-DD')
                            this.list()
                        }
                    }
                },
                dropdown: [
                    {
                        title: 'All Project',
                        data: [],
                        action: (event) => {
                            this.param.project_id = event.target.value
                            this.list()
                        }
                    },
                    {
                        title: 'All Category',
                        data: [],
                        action: (event) => {
                            this.param.income_category_id = event.target.value
                            this.list()
                        }
                    },
                    {
                        title: 'All Payment Method',
                        data: [],
                        action: (event) => {
                            this.param.payment_method = event.target.value
                            this.list()
                        }
                    },
                    {
                        title: 'Cash Received By',
                        data: [],
                        action: (event) => {
                            this.param.cash_received_by = event.target.value
                            this.list()
                        }
                    },
                ],
                download: [
                    {
                        icon: 'pdf',
                        loading: false,
                        action: () => {
                            this.downloadFile('pdf')
                        }
                    }
                ],
                noDataError: ' Please click "+ Add Expense" to add a new Expense',
                total: {
                    colspan: 9,
                    amount: ''
                }
            },
            id: []
        }
    },
    watch: {

    },
    methods: {
        fetchCashReceived: function() {
            ApiService.POST(ApiRoutes.CashReceived + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[3].data = res.data.data;
                }
            });
        },
        fetchAsset: function() {
            ApiService.POST(ApiRoutes.Asset + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[2].data = res.data
                }
            });
        },
        fetchCategory: function() {
            ApiService.POST(ApiRoutes.IncomeCategory + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[1].data = res.data.data
                }
            });
        },
        fetchProject: function() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 100}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.table.dropdown[0].data = res.data.data
                }
            });
        },
        incomeAdd() {
            this.$router.push({
                name: 'incomeAdd'
            })
        },
        async tableIconAction (type, data, index = null) {
            this.id = this.structureReturnData(data)
            if (type === 'edit') {
                const url = this.$router.resolve({
                    name: 'incomeEdit',
                    params: { id: data.id }
                }).href
                window.open(url, '_blank')
            } else if (type === 'view') {
                this.$router.push({
                    name: 'shareholderView',
                    params: { id: data.id }
                })
            } else if (type === 'delete') {
                const ok = await this.$refs.confirmDialogue.show({
                    title: 'Delete Income',
                    message: 'Are you sure you want to delete this Income?',
                    okButton: 'Delete',
                })
                if (ok) {
                    this.delete()
                }
            } else if (type === 'print') {
                if (index != null) {
                    PrintService.print('/income/print/' + data.id);
                }
            }
        },

        list: function (page) {
            if (page === undefined) {
                page = 1
            }
            this.param.page = page;
            this.table.loading = true
            ApiService.POST(ApiRoutes.Income + '/list', this.param, (res) => {
                this.table.loading = false
                if (parseInt(res.status) === 200) {
                    this.table.rows = res.data.data.data;
                    this.table.paginateData = res.data.data;
                    this.table.total.amount = res.data.total;
                }
            });
        },
        delete: function () {
            ApiService.POST(ApiRoutes.Income + '/delete', {id: this.id[0]}, (res) => {
                this.$refs.confirmDialogue._loading(false)
                if (parseInt(res.status) === 200) {
                    this.$toast.success(res.message)
                    this.$refs.confirmDialogue._hide()
                    this.list()
                }
            });
        },
        downloadFile: function (type) {
            let route = type === 'xls' ? ApiRoutes.Income + '/export/excel' : ApiRoutes.Income + '/export/pdf'
            let name = type === 'xls' ? 'income.xlsx' : 'income.pdf'
            DownloadService.download(route, this.table.download, name, type, this.param)
        }
    },
    mounted() {
        this.list()
        this.fetchProject();
        this.fetchCategory();
        this.fetchAsset();
        this.fetchCashReceived();
    },
    created() {
        this.breadCrumb.push(this.$route.name)
    }
}
</script>

<style scoped>

</style>
